import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EtlDictionnaryComponent } from './etl-dictionnary.component';
import { ComponentsModule } from '../../../components/components.module';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { RouterModule } from '@angular/router';
import { EtlDictionnaryEditComponent } from './etl-dictionnary-edit/etl-dictionnary-edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import {RippleModule} from 'primeng/ripple';
import { PipesModule } from '../../../pipes/pipes.module';
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
    declarations: [EtlDictionnaryComponent, EtlDictionnaryEditComponent],
    imports: [
        CommonModule,
        ComponentsModule,
        ButtonModule,
        ToastModule,
        ConfirmDialogModule,
        TableModule,
        TagModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        CheckboxModule,
        InputTextModule,
        MonacoEditorModule,
        DropdownModule,
        DialogModule,
        InputSwitchModule,
        RippleModule,
        PipesModule,
        MenuModule,
        TooltipModule,
        TranslateModule
    ]
})
export class EtlDictionnaryModule { }
